import { Component, OnInit } from '@angular/core';
import { scaleFadeInAnimation } from '@rsm/shared/animations';

import { MessageService, MessageEvent } from '..';

@Component({
  selector: 'toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.scss'],
  animations: [scaleFadeInAnimation(500)],
})
export class ToastComponent implements OnInit {
  public items: MessageEvent[];

  constructor(private messageService: MessageService) {
    this.items = [];
  }

  ngOnInit(): void {
    this.messageService.onMessage.subscribe((event: MessageEvent) => {
      const { autoclose = true } = event.data;

      this.items.push(event);

      if (autoclose) {
        setTimeout(() => this.onHide(event), 10000);
      }
    });
  }

  public onHide(current: MessageEvent): void {
    this.items = this.items.filter((item: MessageEvent) => item !== current);
  }
}
